import { settingsStore, updateSettings } from "../../stores/settingsStore";
import { applyTheme, postThemeToNative } from "../../theme";

type ThemeId = "dark" | "light" | "system";

const OPTIONS: { id: ThemeId; label: string }[] = [
  { id: "dark", label: "Dark" },
  { id: "light", label: "Light" },
  { id: "system", label: "Match system" },
];

export function AppearancePanel() {
  const state = settingsStore.useStore();
  const current = state.settings.appearance.theme;

  async function pick(theme: ThemeId) {
    await updateSettings({ appearance: { theme } });
    // "system" intentionally falls through to "dark" for the dataset attribute
    // until a matchMedia listener is wired up (out of scope for v1).
    const effective = theme === "light" ? "light" : "dark";
    applyTheme(effective);
    postThemeToNative(effective);
  }

  return (
    <div className="settings-panel">
      <h3>Appearance</h3>
      <fieldset className="settings-radio-group">
        <legend className="settings-subhead">Theme</legend>
        {OPTIONS.map((o) => (
          <label key={o.id} className="settings-radio">
            <input
              type="radio"
              name="theme"
              value={o.id}
              checked={current === o.id}
              onChange={() => void pick(o.id)}
            />
            {o.label}
          </label>
        ))}
      </fieldset>
    </div>
  );
}
